module.exports = __webpack_public_path__ + "img/H-63-ST-450-BE.0e54771b.png";